/*
    evita o erro 'cannot read property of undefined
    é útil em caso de objetos com muitas subPropriedades
*/
export function getSafe(fn, defaultVal) {
  try {
    return fn();
  } catch (e) {
    return defaultVal;
  }
}
